import FunctionsIcon from '@mui/icons-material/Functions';
import {
  styled,
  Typography,
} from '@mui/material';
import { purple } from '../../utils/colors';

const StyledTypography = styled(Typography)({
  margin: 0,
  fontSize: 10,
  borderRadius: 4,
  lineHeight: '16px',
  padding: '2px 6px 2px 4px',
  fontWeight: 600,
  textTransform: 'uppercase',
  display: 'inline-flex',
  alignSelf: 'flex-start',
  gap: 4,
  alignItems: 'center',
  maxWidth: 300,
  backgroundColor: purple[500],
  color: 'white',
  cursor: 'default',
  '& svg': {
    display: 'block',
    fontSize: 12,
    flex: '0 0 auto',
  },
  '& .label': {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: '1 1 auto',
  },
});

export default function ComplianceOperationTag(props: { displayText: string }) {
  const { displayText } = props;

  return (
    <StyledTypography title={displayText}>
      <FunctionsIcon />
      <span className="label">{displayText}</span>
    </StyledTypography>
  );
}
